var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroundLoopsHeatPump(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00857D"
    },
    d: "M200,99.999C200,155.227,155.229,200,100.001,200C44.771,200,0,155.227,0,99.999S44.771,0,100.001,0 C155.229,0,200,44.771,200,99.999"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 47.714,
    y: 48.311,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -41.6722 99.7619)",
    style: {
      fill: "#FFFFFF"
    },
    width: 103.746,
    height: 103.746
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9D3CB"
    },
    points: "172.947,100.184 99.588,173.543 26.228,100.184 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00857D"
    },
    d: "M52.95,128.503"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#00857D",
      strokeWidth: 3.2202,
      strokeMiterlimit: 10
    },
    d: "M52.95,128.503"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00857D"
    },
    points: "66.206,70.693 99.652,37.036 133.529,70.693 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00857D"
    },
    d: "M105.157,95.15c0,0,14.278,0.079,18.256,0V81.087V67.633L99.438,43.37L75.446,67.633v13.454V95.15 c3.978,0.079,18.256,0,18.256,0L93.7,82.98h11.453L105.157,95.15z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.359,
    y: 67.159,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.276,
    height: 8.276
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.655,
    y: 67.159,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.276,
    height: 8.276
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00857D"
    },
    d: "M90.24,111.958c0-0.472,0.378-0.897,0.897-0.897h5.62c0.473,0,0.897,0.426,0.897,0.897v25.219 h11.239c0.52,0,0.897,0.425,0.897,0.897v5.147c0,0.473-0.378,0.897-0.897,0.897H91.138c-0.52,0-0.897-0.425-0.897-0.897V111.958z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#00857D",
      strokeWidth: 3.2202,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M119.399,84.484l0.036,53.126c0.193,9.961-9.066,18.172-19.959,18.342c-10.891,0.172-19.664-7.765-19.858-17.726l-0.043-53.757"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundLoopsHeatPump);
export default __webpack_public_path__ + "static/media/ground-loops-heat-pump.057e57240156904f226f16e3764e17e5.svg";
export { ForwardRef as ReactComponent };